// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectHeaderModule_container__1HkRN","projectTitle":"ProjectHeaderModule_projectTitle__1NeDL","projectSubtitle":"ProjectHeaderModule_projectSubtitle__21jRa"};